import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { ThemeProvider } from "@/context/ThemeContext";
import { WorkspaceProvider } from "@/context/WorkspaceContext";
import { Toaster } from "@/components/ui/sonner";
import AuthLayout from "@/pages/AuthLayout";
import WorkspaceGate from "@/pages/WorkspaceGate";

function Protected() {
  return (
    <>
      <Show when="signed-in">
        <WorkspaceProvider>
          <WorkspaceGate />
        </WorkspaceProvider>
      </Show>
      <Show when="signed-out">
        <Navigate to="/sign-in" replace />
      </Show>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/sign-in/*" element={<AuthLayout><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthLayout>} />
            <Route path="/sign-up/*" element={<AuthLayout><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthLayout>} />
            <Route path="/*" element={<Protected />} />
          </Routes>
        </ClerkAuthProvider>
        <Toaster position="top-right" richColors />
      </ThemeProvider>
    </BrowserRouter>
  );
}
